module.exports = __webpack_public_path__ + "static/fonts/355CC9_1_0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_1_0.woff
// module id = 147
// module chunks = 0